import React, { useEffect } from "react";
import KendoDropdown from "../../../components/form/KendoDropdown";
import { useFetchUserLocations } from "./hooks/useFetchUserLocations";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export default function LocationDropdown({
  selectedParentCompany,
  selectedLocations,
  setSelectedLocations,
}) {
  const { data: locationFormatedDataSource = [], isLoading } =
    useFetchUserLocations(selectedParentCompany);

  function dropDownDataSource() {
    if (IsNullOrEmpty(selectedParentCompany)) return [];

    if (IsNullOrEmpty(locationFormatedDataSource)) return [];

    return locationFormatedDataSource;
  }

  function bindingSelectedLocation() {
    if (IsNullOrEmpty(selectedParentCompany)) return null;

    return selectedLocations;
  }

  // Clear selectedLocations if parent company is null/empty or when it changes
  useEffect(() => {
    if (IsNullOrEmpty(selectedParentCompany)) {
      if (!IsNullOrEmpty(selectedLocations)) {
        setSelectedLocations([]);
      }
    } else {
      // Whenever selectedParentCompancsy changes, reset selectedLocations
      setSelectedLocations([]);
    }
  }, [selectedParentCompany]);

  return (
    <KendoDropdown
      dataSource={dropDownDataSource()}
      textField="label"
      idField="value"
      //value={selectedLocations}
      value={bindingSelectedLocation()}
      onChange={(e) => {
        setSelectedLocations(e);
      }}
      loading={isLoading}
    />
  );
}
